var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
function IconWarning(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20" }, props),
        React.createElement("path", { d: "M7.88 3.3a2.36 2.36 0 014.23 0l5.63 11.28A2.37 2.37 0 0115.63 18H4.37a2.37 2.37 0 01-2.12-3.42L7.88 3.3z" }),
        React.createElement("path", { fill: "#fff", d: "M10.73 12.22a.72.72 0 01-1.45 0l-.33-5.16a1 1 0 011-1.06h.11a1 1 0 011 1.06l-.33 5.16zM8.9 14.93c0-.3.1-.57.32-.78.21-.23.47-.34.77-.34.3 0 .57.11.78.34.23.21.34.47.34.78 0 .31-.11.57-.34.79-.21.21-.47.32-.78.32-.3 0-.56-.1-.77-.32a1.07 1.07 0 01-.32-.79z" })));
}
export default IconWarning;
